const getIdClienteMacdata = () => {
    let usr = localStorage.getItem("user")
    let pUsr = usr ? JSON.parse(usr) : null
    let id = localStorage.getItem("client") || pUsr?.cId ||"0"
    return parseInt(id)
}

export default getIdClienteMacdata